<script>
  import { fly } from "svelte/transition";
  import { quintOut } from "svelte/easing";
import { teams } from "../clubs";
  export let team;

  // Load Stats


 // if (team.statsTeam !== "") annual("../../data/stat202021.csv", team.statsTeam);
</script>

<style>
  .clubs {
    background: white;
  }
</style>

<!-- Club record -->
<div class="clubs">
  {#if team.id !== '' && typeof team.id !== 'undefined'}
    <div class="row">
      <div class="col-md">
        <h4 class="text-secondary">Ground</h4>
        <p>
          <a
            class="text-info"
            target="_blank"
            href={team.groundHref}>&nbsp;{team.ground}&nbsp;</a>
        </p>
        {#if team.groundPhone !== ''}
          <p>
            <i class="fas fa-phone" aria-hidden="true" />
            {team.groundPhone}
          </p>
        {/if}
      </div>
      <div class="col-md">
        <div
          transition:fly={{ delay: 250, duration: 300, x: 100, y: 500, opacity: 0.5, easing: quintOut }}
          class="float-right d-none d-md-block badge">
          <picture>
            <source
              media="(max-width: 813px)"
              size="1px"
              srcset="../images/blank.gif" />
            <img src={team.badge} class="img-fluid" alt="Club Badge" />
          </picture>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md">
        <h4 class="text-secondary">Contacts</h4>
        <p>
          Secretary :
          {team.secretary}
          <a href={team.secretaryEmail} class="text-info">Contact by e-mail</a>
        </p>
        <p>Chairman : {team.chairman}</p>
      </div>
      <div class="col-md">
        <h4 class="text-secondary">Programme Details</h4>
        <p>
          Editor :
          {team.programEditor}
          <a href={team.programEditorEmail} class="text-info">Contact by e-mail</a>
        </p>
        {#if team.programHistory !== ''}
          <p>
            <a href={team.programHistory} class="text-info">
              {team.club}
              history
              <i class={team.programHistoryIcon} aria-hidden="true" />
            </a>
          </p>
        {/if}
        {#if team.programProfile !== ''}
          <p>
            <a href={team.programProfile} class="text-info">
              {team.club}
              player profiles
              <i class={team.programProfileIcon} aria-hidden="true" />
            </a>
          </p>
        {/if}
        {#if team.programCar !== ''}
          <p>
            <a href={team.programCar} class="text-info">
              {team.club}
              Car parking details
              <i class={team.programCarIcon} aria-hidden="true" />
            </a>
          </p>
        {/if}
      </div>
      <div class="col-md">
        <div class="d-md-block">
          <h4 class="text-secondary">Social Media</h4>
          {#if team.socialWeb !== ''}
            <p>
              <i class="fas fa-globe" aria-hidden="true" />
              <a
                target="_blank"
                href={team.socialWeb}
                class="text-info">{team.socialWebText}</a>
            </p>
          {/if}
          {#if team.socialTwitter !== ''}
            <p>
              <i class="fab fa-twitter" aria-hidden="true" />
              <a target="_blank" href={team.socialTwitter} class="text-info">
                {team.socialTwitterHandle}
              </a>
            </p>
          {/if}
          {#if team.socialFacebook !== ''}
            <p>
              <i class="fab fa-facebook" aria-hidden="true" />
              <a target="_blank" href={team.socialFacebook} class="text-info">
                {team.socialFacebookHandle}
              </a>
            </p>
          {/if}
          {#if team.socialInsta !== ''}
            <p>
              <i class="fab fa-instagram" aria-hidden="true" />
              <a target="_blank" href={team.socialInsta} class="text-info">
                {team.socialInstaHandle}
              </a>
            </p>
          {/if}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md">
        <h4 class="text-secondary">Colours</h4>
        <div
          transition:fly={{ delay: 250, duration: 300, x: 100, y: 500, opacity: 0.5, easing: quintOut }}
          class="d-block shirt">
          <picture>
            <source
              media="(max-width: 13px)"
              size="1px"
              srcset="../images/blank.gif" />
            {#if team.coloursHomeImage !== ''}
              <img
                src={team.coloursHomeImage}
                class="img-fluid px-0"
                alt="Home Kit" />
            {:else}
              <img src="../images/blank.gif" class="img-fluid" alt="Home Kit" />
            {/if}
          </picture>
        </div>
        <p>{team.coloursHome}</p>
        <br />
        {#if team.coloursHomeImageBack !== ''}
        <div
        transition:fly={{ delay: 250, duration: 300, x: 100, y: 500, opacity: 0.5, easing: quintOut }}
        class="d-block shirt">
        <picture>
          <source
            media="(max-width: 13px)"
            size="1px"
            srcset="../images/blank.gif" />
          {#if team.coloursHomeImageBack !== ''}
            <img
              src={team.coloursHomeImageBack}
              class="img-fluid px-0"
              alt="Home Kit" />
          {:else}
            <img src="../images/blank.gif" class="img-fluid" alt="Home Kit" />
          {/if}
        </picture>
      </div>
      {/if}
      {#if team.coloursHomeImageKeep !== ''}
      <div
      transition:fly={{ delay: 250, duration: 300, x: 100, y: 500, opacity: 0.5, easing: quintOut }}
      class="d-block shirt">
      <picture>
        <source
          media="(max-width: 13px)"
          size="1px"
          srcset="../images/blank.gif" />
        {#if team.coloursHomeImageKeep !== ''}
          <img
            src={team.coloursHomeImageKeep}
            class="img-fluid px-0"
            alt="Home Keepers Kit" />
        {:else}
          <img src="../images/blank.gif" class="img-fluid" alt="Home Keepers Kit" />
        {/if}
      </picture>
    </div>
    {/if}
    {#if team.coloursHomeImageKeepBack !== ''}
    <div
    transition:fly={{ delay: 250, duration: 300, x: 100, y: 500, opacity: 0.5, easing: quintOut }}
    class="d-block shirt">
    <picture>
      <source
        media="(max-width: 13px)"
        size="1px"
        srcset="../images/blank.gif" />
      {#if team.coloursHomeImageKeepBack !== ''}
        <img
          src={team.coloursHomeImageKeepBack}
          class="img-fluid px-0"
          alt="Home Keepers Kit" />
      {:else}
        <img src="../images/blank.gif" class="img-fluid" alt="Home Keepers Kit" />
      {/if}
    </picture>
  </div>
  {/if}

      </div>
      <div class="col-md">
        <h4 class="text-secondary">Change Colours</h4>
        <div
          transition:fly={{ delay: 250, duration: 300, x: 100, y: 500, opacity: 0.5, easing: quintOut }}
          class="d-block shirt">
          <picture>
            <source
              media="(max-width: 13px)"
              size="1px"
              srcset="../images/blank.gif" />
            {#if team.coloursAwayImage !== ''}
              <img
                src={team.coloursAwayImage}
                class="img-fluid"
                alt="Change Kit" />
            {:else}
              <img
                src="../images/blank.gif"
                class="img-fluid"
                alt="Change Kit" />
            {/if}
          </picture>
        </div>
        <p>{team.coloursAway}</p>
      </div>
    </div>

    <!--Team Photo-->
    {#if team.teamImage !== ''}
      <div class="row">
        <div class="col-md">
          <h4 class="text-secondary">Team Photo</h4>
          <img src={team.teamImage} class="img-fluid" alt={team.club} />
        </div>
      </div>
    {/if}
    <!--Stats-->
    {#if team.statsTeam !== ''}
      <div class="row">
        <div class="col-md">
          <h4 class="text-secondary">League Stats</h4>
          <iframe src="./clubstats.html?club={team.statsTeam}" title="Club Stats"  width="100%" height="800"  frameborder="0"></iframe>
        </div>
      </div>
    {/if}
  {/if}
</div>
